import { SLICE_NAME } from 'config/type';

export const GET_CRM_MESSAGES = SLICE_NAME.CRM + 'GET_CRM_MESSAGES';
export const CREATE_CRM_MESSAGES = SLICE_NAME.CRM + 'CREATE_CRM_MESSAGES';
export const UPDATE_CRM_MESSAGE_READ = SLICE_NAME.CRM + 'UPDATE_CRM_MESSAGE_READ';
export const GET_TRANSITION_OF_FRIENDS = SLICE_NAME.CRM + 'GET_TRANSITION_OF_FRIENDS';
